export default "/_next/static/images/d975d7d45ed8d776a62909ea6e00c344.svg";